/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Directory_Home_Faq_Q3Inputs */

const en_directory_home_faq_q3 = /** @type {(inputs: Directory_Home_Faq_Q3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`How does a product get listed?`)
};

const zh_directory_home_faq_q3 = /** @type {(inputs: Directory_Home_Faq_Q3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`产品如何被收录？`)
};

/**
* | output |
* | --- |
* | "How does a product get listed?" |
*
* @param {Directory_Home_Faq_Q3Inputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const directory_home_faq_q3 = /** @type {((inputs?: Directory_Home_Faq_Q3Inputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Directory_Home_Faq_Q3Inputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_directory_home_faq_q3(inputs)
	return zh_directory_home_faq_q3(inputs)
});
export { directory_home_faq_q3 as "directory.home.faq.q3" }